const defaultState = {
  mapLayers: [],
  isLoading: false,
  error: false,
};

const trackerMap = function (state = defaultState, action) {
  switch (action.type) {
    case "ADD_MAP_LAYER":
      return { ...state, mapLayers: [] };

    case "REMOVE_MAP_LAYER":
      return { ...state, mapLayers: [] };

    case "UPDATE_MAP_LAYER":
      return { ...state, mapLayers: [] };

    case "CLEAR_MAP_LAYERS":
      return { ...state, mapLayers: [] };

    case "TRACKER_MAP_IS_LOADING":
      return {
        ...state, mapLayers: [],
        isLoading: !!action.data,
      };

    case "TRACKER_MAP_ERROR":
      return {
        ...state, mapLayers: [],
        error: !!action.data,
      };

    default:
      return { ...state, mapLayers: [] };
  }
};

export default trackerMap;
